import {
  Shirt,
  Eye,
  Glasses,
  User,
  Palette,
  Trees,
  Building2,
  Home,
} from "lucide-react";

export const shopItems = [
  // Environments
  {
    id: "lightblue",
    name: "Light Blue",
    category: "environment",
    cost: 0,
    icon: Building2,
  },
  {
    id: "lightgreen",
    name: "Light Green",
    category: "environment",
    cost: 0,
    icon: Home,
  },
  {
    id: "blue",
    name: "Blue",
    category: "environment",
    cost: 0,
    icon: Trees,
  },
  {
    id: "darkpink",
    name: "Dark Pink",
    category: "environment",
    cost: 0,
    icon: Trees,
  },
  {
    id: "purple",
    name: "Purple",
    category: "environment",
    cost: 0,
    icon: Trees,
  },
  {
    id: "yellow",
    name: "Yellow",
    category: "environment",
    cost: 0,
    icon: Trees,
  },

  // Skin Colors
  // Skin Colors - now points to actual image files
  { id: "pink", name: "Pink", category: "skinColor", cost: 0, icon: Palette },
  {
    id: "purple",
    name: "Purple",
    category: "skinColor",
    cost: 0,
    icon: Palette,
  },
  {
    id: "lightbrown",
    name: "Light Brown",
    category: "skinColor",
    cost: 0,
    icon: Palette,
  },
  { id: "brown", name: "Brown", category: "skinColor", cost: 0, icon: Palette },
  { id: "blue", name: "Blue", category: "skinColor", cost: 0, icon: Palette },
  { id: "green", name: "Green", category: "skinColor", cost: 0, icon: Palette },

  // Hair
  {
    id: "longpurple",
    name: "Long Purple",
    category: "hair",
    cost: 20,
    icon: Palette,
  },
  {
    id: "shortblue",
    name: "Short Blue",
    category: "hair",
    cost: 30,
    icon: User,
  },
  {
    id: "shortbrown",
    name: "Short Brown",
    category: "hair",
    cost: 0,
    icon: User,
  },
  {
    id: "longblonde",
    name: "Long Blonde",
    category: "hair",
    cost: 20,
    icon: User,
  },
  {
    id: "longblack",
    name: "Long Black",
    category: "hair",
    cost: 20,
    icon: User,
  },

  // Hats
  {
    id: "surgicalcap",
    name: "Surgery Cap",
    category: "hat",
    cost: 0,
    icon: Eye,
  },
  {
    id: "bluesurgicalcap",
    name: "Surgery Cap",
    category: "hat",
    cost: 0,
    icon: Eye,
  },
  {
    id: "pinksurgicalcap",
    name: "Surgery Cap",
    category: "hat",
    cost: 0,
    icon: Eye,
  },
  { id: "tophat", name: "Top Hat", category: "hat", cost: 0, icon: Eye },
  {
    id: "skimask",
    name: "Surgical Hood",
    category: "hat",
    cost: 50,
    icon: Eye,
  },
  {
    id: "greenbeanie",
    name: "Green Beanie",
    category: "hat",
    cost: 0,
    icon: Eye,
  },
  {
    id: "monsterhat",
    name: "Monster Hat",
    category: "hat",
    cost: 30,
    icon: Eye,
  },
  {
    id: "sailorhat",
    name: "Sailor Hat",
    category: "hat",
    cost: 60,
    icon: Eye,
  },
  {
    id: "orangecap",
    name: "Orange Cap",
    category: "hat",
    cost: 0,
    icon: Eye,
  },
  {
    id: "catband",
    name: "Cat Band",
    category: "hat",
    cost: 0,
    icon: Eye,
  },

  // Glasses
  {
    id: "roundglasses",
    name: "Round Glasses",
    category: "glasses",
    cost: 0,
    icon: Glasses,
  },
  {
    id: "piratepatch",
    name: "Pirate Patch",
    category: "glasses",
    cost: 30,
    icon: Glasses,
  },
  {
    id: "monocle",
    name: "Monocle",
    category: "glasses",
    cost: 20,
    icon: Glasses,
  },
  {
    id: "sunglasses",
    name: "Sunglasses",
    category: "glasses",
    cost: 0,
    icon: Glasses,
  },

  // Eyebrows
  {
    id: "angry",
    name: "Angry Brows",
    category: "eyebrows",
    cost: 0,
    icon: Eye,
  },
  {
    id: "happy",
    name: "Happy Brows",
    category: "eyebrows",
    cost: 0,
    icon: Eye,
  },
  {
    id: "thick",
    name: "Thick Brows",
    category: "eyebrows",
    cost: 0,
    icon: Eye,
  },
  {
    id: "suspicious",
    name: "Suspicious Brows",
    category: "eyebrows",
    cost: 0,
    icon: Eye,
  },
  {
    id: "curly",
    name: "Curly Brows",
    category: "eyebrows",
    cost: 0,
    icon: Eye,
  },

  // Beard
  {
    id: "mask",
    name: "Mask",
    category: "beard",
    cost: 40,
    icon: User,
  },
  {
    id: "brownmustache",
    name: "Brown Mustache",
    category: "beard",
    cost: 0,
    icon: User,
  },
  {
    id: "blackmustache",
    name: "Black Mustache",
    category: "beard",
    cost: 0,
    icon: User,
  },
  {
    id: "blacklongbeard",
    name: "Black Long Beard",
    category: "beard",
    cost: 0,
    icon: User,
  },
  {
    id: "brownlongbeard",
    name: "Brown Long Beard",
    category: "beard",
    cost: 0,
    icon: User,
  },
  {
    id: "blondelongbeard",
    name: "Blonde Long Beard",
    category: "beard",
    cost: 0,
    icon: User,
  },

  // Tops
  {
    id: "bluescrubs",
    name: "Blue Scrubs",
    category: "top",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "greenscrubs",
    name: "Green Scrubs",
    category: "top",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "pinkscrubs",
    name: "Pink Scrubs",
    category: "top",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "beescrubs",
    name: "Bee Scrubs",
    category: "top",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "whitetop",
    name: "White Top",
    category: "top",
    cost: 20,
    icon: Shirt,
  },
  {
    id: "whitecroptop",
    name: "White Crop Top",
    category: "top",
    cost: 30,
    icon: Shirt,
  },

  // Bottoms
  {
    id: "heartunderwear",
    name: "Heart Underwear",
    category: "bottom",
    cost: 50,
    icon: Shirt,
  },
  {
    id: "bluescrubs",
    name: "Blue Scrubs",
    category: "bottom",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "greenscrubs",
    name: "Green Scrubs",
    category: "bottom",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "pinkscrub",
    name: "Pink Scrubs",
    category: "bottom",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "blackscrubs",
    name: "Black Scrubs",
    category: "bottom",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "dottedscrubs",
    name: "Dotted Scrubs",
    category: "bottom",
    cost: 0,
    icon: Shirt,
  },
  {
    id: "pinkskirt",
    name: "Pink Skirt",
    category: "bottom",
    cost: 20,
    icon: Shirt,
  },
  // Mouth
  {
    id: "teeth",
    name: "Teeth",
    category: "mouth",
    cost: 0,
    icon: User,
  },
  {
    id: "tongue",
    name: "Tongue",
    category: "mouth",
    cost: 0,
    icon: User,
  },
];
